import { PointLayer } from '@sofarocean/mapbox-context';
import { PointLayerProps } from '@sofarocean/mapbox-context/dist/components/layers/PointLayer';
import { useEffect, useMemo, useState } from 'react';

import { useGeoLocation } from '@/hooks/useGeoLocation';

const MY_LOCATION_PULSE_INTERVAL = 1000;

export const MyLocationLayer = () => {
    const { coords, pending } = useGeoLocation();
    const [strokeColor, setStrokeColor] = useState('#ffffff');

    const style = useMemo<PointLayerProps['style']>(
        () => ({
            paint: {
                'circle-color': '#0288d1',
                'circle-stroke-color': strokeColor,
                'circle-stroke-color-transition': { duration: MY_LOCATION_PULSE_INTERVAL, delay: 0 },
                'circle-stroke-width': ['interpolate', ['exponential', 2], ['zoom'], 2, 2, 8, 4],
                'circle-stroke-opacity': 1,
                'circle-radius': ['interpolate', ['exponential', 2], ['zoom'], 2, 4, 5, 8],
            },
            layout: {},
        }),
        [strokeColor]
    );

    useEffect(() => {
        let lastColor = '';
        const interval = setInterval(() => {
            if (lastColor === '#ffffff') {
                lastColor = '#88ccff';
            } else {
                lastColor = '#ffffff';
            }
            setStrokeColor(lastColor);
        }, MY_LOCATION_PULSE_INTERVAL);
        return () => clearInterval(interval);
    }, []);

    const points = useMemo<PointLayerProps['points']>(() => {
        if (pending || !coords) return [];

        return [
            {
                id: 'my-location',
                latitude: coords.latitude,
                longitude: coords.longitude,
            },
        ];
    }, [pending, coords]);

    return <PointLayer type="circle" style={style} points={points} />;
};
